import { FC, useEffect } from "react";
import Dialog, { DialogTitle, DialogContent } from "@/components/Dialog";
import Typography from "@/components/Typography";
import Button from "@/components/Button";
import { useTrackers } from "@/hooks";
import styles from "./CompletedTripLockDialog.module.scss";

type Props = {
  onClose: () => void;
};

const CompletedTripLockDialog: FC<Props> = ({ onClose }) => {
  const { track } = useTrackers();

  useEffect(() => {
    track("Job Locked Completed Trip Dialog Opened", {
      eventId: "job-locked-completed-trip-dialog-opened",
    });
  }, []);

  const handleClose = () => {
    track("Job Locked Completed Trip Clicked", {
      eventId: "job-locked-completed-trip-clicked",
    });
    onClose();
  };

  return (
    <Dialog
      open
      classes={{ paper: styles.paper }}
      BackdropProps={{
        classes: { root: styles.backdrop },
      }}
    >
      <DialogContent className={styles.content}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={"/images/jobs-coordinator-lock.svg"}
          alt="icon"
          className={styles.image}
        />
        <Typography variant="h6" className={styles.title}>
          Your trip is complete. Access to the job board is no longer available.
        </Typography>

        <Button onClick={handleClose} className={styles.button}>
          Go To Dashboard
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default CompletedTripLockDialog;
